import { lazy } from "react";
import Loadable from "components/Loadable";

const LoginPage = Loadable(lazy(() => import("../pages/auth/Login")));
const RegisterPage = Loadable(lazy(() => import("../pages/auth/Register")));
const NotFound404Page = Loadable(lazy(() => import("../components/Page404")));
const VerifyPage = Loadable(lazy(() => import("../sections/auth/AuthVerifyOTP")));
const AuthForgotPassword = Loadable(lazy(() => import("../sections/auth/AuthForgotPassword")));
const ResetPasswordPage = Loadable(lazy(() => import("../sections/auth/AuthResetPassword")));

const publicRoutes = [
	{
		path: "/",
		name: "Login",
		element: <LoginPage />,
	},
	{
		path: "/register",
		name: "Register",
		element: <RegisterPage />,
	},
	{
		path: "/verify",
		name: "Verify",
		element: <VerifyPage />,
	},
	{
		path: "/404",
		name: "Not Found",
		element: <NotFound404Page />,
	},
	{
		path: "/forgot-password",
		element: <AuthForgotPassword />,
	},
	{
		path: "/reset-password",
		element: <ResetPasswordPage />,
	},
];

export default publicRoutes;
